<script setup lang="ts">
import ScaleMenuState from "@/stores/ScaleMenuState";
import ForceTextInput from "@/components/UI/form/ForceTextInput.vue";

/**
 * Hauteur de texte forcée de l'échelle active. Partagé par la liste des
 * échelles de l'en-tête et par la popup Légende + échelle des petits écrans.
 */
</script>

<template>
  <ForceTextInput
    v-model="ScaleMenuState.forcedSize"
    v-model:forced="ScaleMenuState.isTextsizeForced"
    :label="$t('canvas:settings.scale.force.header')"
    :initial-value="ScaleMenuState.activeScaleSize()"
    @change="ScaleMenuState.forceTextsize()"
  />
</template>
